// extracted by mini-css-extract-plugin
module.exports = {"PreviewFrame":"PreviewFrame_PreviewFrame__39TXi"};